const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnShareDocXs(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.987 225.305a1.009 1.009 0 0 0-.044-.222.98.98 0 0 0-.12-.2 1.249 1.249 0 0 0-.072-.119l-5.376-5.859-.014-.01a.974.974 0 0 0-.2-.142 1.075 1.075 0 0 0-.115-.08.956.956 0 0 0-.131-.03.924.924 0 0 0-.242-.05H507.983a.986.986 0 0 0-.975 1V235.6a.986.986 0 0 0 .975 1h13.05a.985.985 0 0 0 .975-1v-10.153a.978.978 0 0 0-.021-.142zm-5.349-3.2 2.133 2.324-2.133-.019zm3.426 12.492h-11.1v-14.012h5.725v4.815a.987.987 0 0 0 .967 1l4.409.038z",
    transform: "translate(-502.014 -215.592)",
    style: {
      fill: "current"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnShareDocXs);
export default __webpack_public_path__ + "static/media/btn-share-doc-xs.b01242ab788ca198adc2e8f57edf2fa1.svg";
export { ForwardRef as ReactComponent };